const $ = require('jquery');
const Browser = require('@trello/browser');
const Footer = require('app/scripts/views/footer');

const {
  currentModelManager,
} = require('app/scripts/controller/currentModelManager');

module.exports = {
  maybeShowFooterChrome(url) {
    const $el = $('#footer-chrome');
    $el.hide();

    if (Browser.isEmbeddedDocument() && currentModelManager.onAnyBoardView()) {
      $el.show();
      const footerView = new Footer({ url });
      return $el.html(footerView.render().el);
    }
  },
};
